import React from "react";
import { Drawer, Switch, Select, Input, Button } from "antd";
import { CarOutlined, GiftOutlined, ReloadOutlined } from "@ant-design/icons";
import Close from "../../../../assets/images/close-x.svg";

const { Option } = Select;

const AdditionalChargesDrawer = ({
  additionalCharges,
  setAdditionalCharges,
  serviceChargeEnabled,
  setServiceChargeEnabled,
  serviceChargePercentage,
  setServiceChargePercentage,
  serviceChargeAmount,
  tipMode,
  setTipMode,
  tipPercentage,
  setTipPercentage,
  tipAmount,
  setTipAmount,
  deliveryCharge,
  setDeliveryCharge,
  packingCharge,
  setPackingCharge,
  roundingOption,
  setRoundingOption,
  currenciesList,
  pricePrecision,
  toFixedTruncate,
  resetToInitialState,
  handleApplyCharges,
  setCart,
}) => {
  return (
    <Drawer
      title={
        <div style={{ display: "flex", fontSize: "1vw", alignItems: "center" }}>
          <p style={{ fontSize: "1.5em", fontWeight: 600, color: "#0F0718", flex: 1 }}>Additional Charges</p>
          <img
            src={Close}
            onClick={() => {
              resetToInitialState(setCart);
              setAdditionalCharges(false);
            }}
            style={{ float: "right", cursor: "pointer", marginTop: "-3vh", marginRight: "-0.5vw", width: "1.5vw" }}
          />
        </div>
      }
      closable={false}
      maskClosable={false}
      placement="right"
      closeIcon={null}
      open={additionalCharges}
      headerStyle={{ backgroundColor: "#f3f4f9", borderBottom: "none" }}
      bodyStyle={{ backgroundColor:"#F3F4F9" }}
      width={400}
      onClose={() => {
        resetToInitialState(setCart);
        setAdditionalCharges(false);
      }}
    >
      {/* Service Charge */}
      <div style={{ marginBottom: "15px", display: "flex", justifyContent: "space-between" }}>
        <span style={{ fontSize: "15px", fontWeight: 550 }}>% Service Charge</span>
        <Switch
          checked={serviceChargeEnabled}
          onChange={(checked) => setServiceChargeEnabled(checked)}
          style={{ marginRight: "10px" }}
        />
      </div>
      <div style={{ marginBottom: "15px", display: "flex", alignItems: "center" }}>
        <Select
          value={serviceChargePercentage}
          onChange={(value) => setServiceChargePercentage(value)}
          disabled={!serviceChargeEnabled}
          style={{ width: "80px", marginRight: "10px" }}
        >
          <Option value={5}>5%</Option>
          <Option value={7}>7%</Option>
          <Option value={10}>10%</Option>
          <Option value={12}>12%</Option>
          <Option value={15}>15%</Option>
        </Select>
        <span style={{ marginLeft: "10px" }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          {toFixedTruncate(serviceChargeAmount, pricePrecision)}
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </span>
      </div>

      {/* Tip */}
      <div style={{ marginBottom: "15px" }}>
        <p style={{ marginBottom: "8px", fontSize: "15px", fontWeight: 550 }}>
          {currenciesList[0].symbolRightSide === "Y" ? `${currenciesList[0].currSymbol} ` : ""}
          Tip
          {currenciesList[0].symbolRightSide === "N" ? ` ${currenciesList[0].currSymbol}` : ""}
        </p>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Select
            value={tipMode}
            onChange={(value) => {
              setTipMode(value);
              setTipPercentage(0);
              setTipAmount(0);
            }}
            style={{ width: 130, marginRight: "10px" }}
          >
            <Option value="Percentage">Percentage</Option>
            <Option value="Amount">Amount</Option>
          </Select>
          {tipMode === "Percentage" ? (
            <Select
              value={tipPercentage}
              onChange={(value) => setTipPercentage(value)}
              style={{ width: "80px", marginRight: "10px" }}
            >
              <Option value={0}>0%</Option>
              <Option value={5}>5%</Option>
              <Option value={7}>7%</Option>
              <Option value={10}>10%</Option>
              <Option value={12}>12%</Option>
              <Option value={15}>15%</Option>
            </Select>
          ) : (
            <Input
              value={tipAmount}
              onChange={(e) => setTipAmount(parseFloat(e.target.value) || 0)}
              style={{ width: "100px", textAlign: "right" }}
              prefix={`${currenciesList[0].currSymbol}`}
            />
          )}
        </div>
      </div>

      {/* Delivery Charge */}
      <div style={{ marginBottom: "15px" }}>
        <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
          <span style={{ marginRight: "8px" }}>
            <CarOutlined />
          </span>{" "}
          Delivery Charge
        </p>
        <Input
          value={deliveryCharge}
          onChange={(e) => setDeliveryCharge(parseFloat(e.target.value) || 0)}
          style={{ width: "100px", textAlign: "right" }}
          prefix={`${currenciesList[0].currSymbol}`}
        />
      </div>

      {/* Packing Charge */}
      <div style={{ marginBottom: "15px" }}>
        <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
          <span style={{ marginRight: "8px" }}>
            <GiftOutlined />
          </span>{" "}
          Packing Charge
        </p>
        <Input
          value={packingCharge}
          onChange={(e) => setPackingCharge(parseFloat(e.target.value) || 0)}
          style={{ width: "100px", textAlign: "right" }}
          prefix={`${currenciesList[0].currSymbol}`}
        />
      </div>

      {/* Rounding */}
      <div style={{ marginBottom: "15px" }}>
        <p style={{ marginBottom: "8px", display: "flex", alignItems: "center", fontSize: "15px", fontWeight: 550 }}>
          <span style={{ marginRight: "8px" }}>
            <ReloadOutlined />
          </span>{" "}
          Rounding
        </p>
        <Select
          value={roundingOption}
          onChange={(value) => setRoundingOption(value)}
          style={{ width: "150px" }}
        >
          <Option value="No Rounding">No Rounding</Option>
          <Option value="Round Up">Round Up</Option>
          <Option value="Round Down">Round Down</Option>
        </Select>
      </div>

      {/* Buttons */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "50px" }}>
        <Button
          style={{
            backgroundColor: "#fff",
            color: "#2F3856",
            height: "40px",
            width: "100px",
            borderRadius: "5px",
            marginRight: "10px",
          }}
          onClick={() => {
            resetToInitialState(setCart);
            setAdditionalCharges(false);
          }}
        >
          Cancel
        </Button>
        <Button
          style={{
            backgroundColor: "#2F3856",
            color: "#fff",
            height: "40px",
            width: "140px",
            borderRadius: "5px",
            textAlign: "center",
          }}
          onClick={() => handleApplyCharges(setCart)}
        >
          Apply Charges
        </Button>
      </div>
    </Drawer>
  );
};

export default AdditionalChargesDrawer;
